import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { BadgeDTO } from 'client-generator/generated-clients/plants';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';

@Options({
  name: 'BadgeItem',
  props: {
    badge: {
      type: Object as PropType<BadgeDTO>,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    badgeTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    offline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    DialogConfirmDelete,
  },
  emits: ['delete-badge'],
})
export default class BadgeItem extends Vue {
  badge!: BadgeDTO;
  small!: boolean;
  badgeTab!: boolean;
  isVisibleDeleteBadgeConfirm = false;
  disabled!: boolean;
  offline!: boolean;
  
  toggleDeleteBadgeConfirm() {
    this.isVisibleDeleteBadgeConfirm = !this.isVisibleDeleteBadgeConfirm;
  }

  async handleDeleteBadge() {
    this.$emit('delete-badge', this.badge);
  }
}
